import ownerDocument from './owner-document'

export default function ownerWindow(
  node?: Element | Document | null
): Window & typeof globalThis {
  const doc = node ? ownerDocument(node) : undefined
  return (doc && doc.defaultView) || window
}
